import { useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMeContext } from '../api/me-provider.js';
import { usePracticeOutbox } from '../api/use-practice-outbox.js';
import { ReculHost } from '../components/recul-host.js';

/**
 * SwingReplay from Tools, the whole screen, with no lesson (stage 4; mockup
 * boards 7 and 8, approved 25 October).
 *
 * A PRACTICE (rulings 27 October and 1 November): leaving with at least one
 * swing saves the swings and time at once, then opens the Done screen. Time is
 * first swing to last. It belongs to the athlete signed in, or to the child a
 * parent picked (?for=). With no swings, or with nobody to belong to, leaving
 * is what it always was.
 *
 * Recul itself is unchanged (RE-16): it is sent no athletes, so it looks as it
 * did, and clips stay on the phone as the Clips switch says.
 */
export function ToolsReculRoute() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { state } = useMeContext();
  const outbox = usePracticeOutbox();
  const swings = useRef({ count: 0, first: '', last: '' });

  function swing(total: number) {
    const at = new Date().toISOString();
    swings.current = { count: total, first: swings.current.first || at, last: at };
  }

  function leave() {
    const athleteClientId = state.status === 'athlete' ? state.athlete.client_id : params.get('for');
    const { count, first, last } = swings.current;
    if (athleteClientId && count > 0) {
      const id = crypto.randomUUID();
      outbox.add({
        id,
        athleteClientId,
        practiceDate: localDate(new Date(first)),
        firstSwingAt: first,
        lastSwingAt: last,
        swingCount: count,
      });
      navigate(`/tools/practice/${id}`, { replace: true });
      return;
    }
    // Back to wherever Recul was opened from.
    if (window.history.length > 1) navigate(-1);
    else navigate('/', { replace: true });
  }

  return <ReculHost context={{ when: '', athletes: [], current: null }} onExit={leave} onPracticeSwing={swing} />;
}

/** The date on the phone (ruled 1 November), not the date in UTC. */
function localDate(when: Date): string {
  const month = String(when.getMonth() + 1).padStart(2, '0');
  const day = String(when.getDate()).padStart(2, '0');
  return `${when.getFullYear()}-${month}-${day}`;
}
